import {Api} from "../config/request";

export default {
  bulkUploadIncentiveMultipliers(payload){
    return Api.post("/incentive-multipliers/bulk-upload", payload);
  },
};